import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { MILESTONES } from '@/mocks/schedule';
import { formatCnDate, daysUntil } from '@/utils/date';

const KIND_META: Record<string, { label: string; icon: string; cls: string }> = {
  deadline: { label: '截稿', icon: 'ri-timer-flash-line', cls: 'bg-primary-100 text-primary-700' },
  vote: { label: '开投', icon: 'ri-checkbox-multiple-line', cls: 'bg-accent-100 text-accent-800' },
  result: { label: '出结果', icon: 'ri-award-line', cls: 'bg-secondary-100 text-secondary-800' },
  event: { label: '现场', icon: 'ri-live-line', cls: 'bg-secondary-100 text-secondary-800' },
};

export default function KeyMilestones() {
  const items = MILESTONES.slice(0, 4);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50" aria-labelledby="milestone-heading">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <SectionHeading
            id="milestone-heading"
            eyebrow="Key Dates"
            title="关键时间节点，先看这四个"
            desc="截稿、开投、出结果三类节点用不同标记区分，日程最急的那件事一眼就能找到。"
          />
          <Link
            to="/schedule"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 text-foreground-700 text-sm whitespace-nowrap hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer shrink-0"
          >
            全部时间节点
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((m) => {
            const meta = KIND_META[m.kind];
            const left = daysUntil(m.date);
            return (
              <article
                key={m.date}
                className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 hover:border-primary-300 transition-colors"
              >
                <div className="flex items-center justify-between">
                  <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-medium ${meta.cls}`}>
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className={meta.icon}></i>
                    </span>
                    {meta.label}
                  </span>
                  <span className="text-xs text-foreground-500">
                    {left > 0 ? `还有 ${left} 天` : '已结束'}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{m.title}</h3>
                <p className="mt-1 text-sm text-primary-600 font-medium">{formatCnDate(m.date)}</p>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{m.detail}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}